module.exports = __webpack_public_path__ + "static/media/bgImage.44c84c30.jpg";